import { Box, Stack } from '@mui/material';
import { useUserSettings } from '#/features/user';
import { useStorageItem } from '#/lib/storage';
import { ThemeSwitch } from '#/theme';
import SettingsSectionHeader from '../SettingsSectionHeader';

function Appearance() {
  const userSettings = useUserSettings();
  // @todo: remove this once we've migrated all users
  const migratedState = useStorageItem<boolean>(
    'settings::appearance::mode::migrated'
  );
  return (
    <Box>
      <SettingsSectionHeader
        title='Appearance'
        description='Choose how Joggr appears to you, such as changing the interface theme.'
      />
      <Stack direction='column' spacing={2}>
        <ThemeSwitch
          onChange={(theme) => {
            userSettings.onUpdate({ theme });
            migratedState.set(true);
          }}
          helperText='Automatically set based on your system'
        />
      </Stack>
    </Box>
  );
}

export default Appearance;
